import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { apiAuthGet, getToken, clearToken } from "@/lib/api";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const [state, setState] = useState({ checking: true, ok: false });

  useEffect(() => {
    const token = getToken();
    if (!token) { setState({ checking: false, ok: false }); return; }
    apiAuthGet("/auth/me")
      .then(() => setState({ checking: false, ok: true }))
      .catch(() => { clearToken(); setState({ checking: false, ok: false }); });
  }, []);

  if (state.checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950">
        <div className="w-10 h-10 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" data-testid="admin-loader" />
      </div>
    );
  }
  if (!state.ok) return <Navigate to="/admin/login" replace state={{ from: location }} />;
  return children;
}
